import { SectionContainer } from "../molecules/section-container";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RectangleList } from "../molecules/reactangle-container-list";
import { Button } from "../atoms/button";
import { useTasks } from "../../providers/task-provider";
import { useSubmission } from "../../providers/submission-provider";
import { useAuth } from "../../auth/AuthContext";

export const TaskSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const { tasks, setCurrentTask, currentTask, fetchTasks } = useTasks();
  const {
    initializeSubmission,
    setSubmissionProperties,
    setSubmissionMetadata,
  } = useSubmission();
  const { user } = useAuth() as any;

  useEffect(() => {
    fetchTasks(user?.accessToken).then(() => null);
    initializeSubmission({
      category_id: undefined,
      device_info: {},
      location_info: null,
      submission_metadata: {
        sound_type: "",
      },
    });
    setCurrentTask(null);
  }, []);

  return (
    <SectionContainer title="Perle Collect">
      <h2 className="text-left mb-2">Available Tasks</h2>
      {!currentTask && (
        <RectangleList
          items={tasks.map((task) => (
            <div className="flex justify-between">
              <div>
                <h3 className="text-left">{task.name}</h3>
                <div className="text-sm">
                  {`${task.available_tasks_count} recordings left`}
                </div>
                <div className="text-sm text-dark-gray-1 font-bold">
                  $.25 per recording
                </div>
              </div>
              <div>
                <Button
                  text="Select"
                  type="primary"
                  onClick={() => {
                    setCurrentTask(task);
                    setSubmissionProperties({
                      category_id: task?.id,
                    });
                    setSubmissionMetadata({
                      sound_type: task?.name,
                    });
                    if (task.subcategories.length === 1) {
                      setSubmissionMetadata({
                        sub_category: task.subcategories[0].name,
                      });
                      setSubmissionProperties({
                        subcategory_id: task.subcategories[0].id,
                      });
                      navigate("/recording");
                    }
                  }}
                />
              </div>
            </div>
          ))}
        />
      )}
      {currentTask && (
        <RectangleList
          items={currentTask.subcategories.map((subcategories) => (
            <div className="flex justify-between">
              <div>
                <h3 className="text-left">{subcategories.name}</h3>
                <div className="text-sm text-dark-gray-1 font-bold">
                  $.25 per recording
                </div>
              </div>
              <div>
                <Button
                  text="Start"
                  type="primary"
                  onClick={() => {
                    setSubmissionMetadata({
                      sub_category: subcategories.name,
                    });
                    setSubmissionProperties({
                      subcategory_id: subcategories.id,
                    });
                    navigate("/recording");
                  }}
                />
              </div>
            </div>
          ))}
        />
      )}
      {/*<div className="flex justify-between mt-4">*/}
      {/*  <div>*/}
      {/*    <h4 className="text-left">Your Stats</h4>*/}
      {/*    <p className="text-dark-gray-1 font-bold text-sm">*/}
      {/*      Contributor since March 2025*/}
      {/*    </p>*/}
      {/*  </div>*/}
      {/*  <div>*/}
      {/*    <h4 className="text-right">Quality Score</h4>*/}
      {/*    <p className="text-progress-ok font-bold text-sm">94% (Excellent)</p>*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*<div className="flex gap-4 mt-4">*/}
      {/*  <div className="bg-medium-gray rounded flex flex-col font-bold grow pt-1 pb-1 text-sm">*/}
      {/*    <span>12</span>*/}
      {/*    <span>Completed</span>*/}
      {/*  </div>*/}
      {/*  <div className="bg-medium-gray rounded flex flex-col font-bold grow pt-1 pb-1 text-sm">*/}
      {/*    <span>$27.5</span>*/}
      {/*    <span>Earned</span>*/}
      {/*  </div>*/}
      {/*  <div className="bg-medium-gray rounded flex flex-col font-bold grow pt-1 pb-1 text-sm">*/}
      {/*    <span>2</span>*/}
      {/*    <span>Rejected</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </SectionContainer>
  );
};
